// extracted by mini-css-extract-plugin
module.exports = {"sidedrawer":"sidedrawer_sidedrawer__1Kj1f","about":"sidedrawer_about__7B8IB","logo":"sidedrawer_logo__1hV95"};